export abstract class CmsDeserializer {
  public static parseSlider(sliderString: string): SliderPage[] {
    const parts = sliderString.split(';;');
    return parts.map(this.parseSliderPage);
  }

  public static parseSliderPage(pageString: string): SliderPage {
    const parts = pageString.split('#;#');
    if (parts.length !== 6) {
      throw Error(`Invalid slider page format: ${pageString}`);
    }
    return {
      imageUrl: parts[0],
      title: parts[1],
      linkTarget: parts[2],
      linkText: parts[3],
      linkHtmlTarget: parts[4],
      deliveryText: parts[5]
    };
  }

  public static parseGallery(galleryString: string): GalleryPage[] {
    const parts = galleryString.split(';;');
    return parts.map(this.parseGalleryPage);
  }

  public static parseGalleryPage(pageString: string): GalleryPage {
    const parts = pageString.split('#;#');
    if (parts.length !== 2) {
      throw Error(`Invalid gallery page format: ${pageString}`);
    }
    return {
      imageUrl: parts[0],
      subTitle: parts[1],
    };
  }

  public static parseTeaserTiles(localTiles: string): TeaserTile[] {
    const parts = localTiles.split(';;');
    return parts.map(this.parseTeaserTile);
  }

  public static parseTeaserTile(tileString: string): TeaserTile {
    const parts = tileString.split('#;#');
    if (parts.length !== 4) {
      throw Error(`Invalid tile string format: ${tileString}`);
    }
    return {
      title: parts[0],
      teaserText: parts[1],
      imageUrl: parts[2],
      url: parts[3]
    };
  }
}

export interface SliderPage {
  imageUrl: string;
  title: string;
  linkTarget: string;
  linkText: string;
  linkHtmlTarget: string;
  deliveryText: string;
}

export interface GalleryPage {
  imageUrl: string;
  subTitle: string;
}

export interface TeaserTile {
  title: string;
  teaserText: string;
  imageUrl: string;
  url: string;
}
